/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-21 16:28:19
 * @LastEditors: liuziwei
 * @Description: 首页领券 banner
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="banner-container">
    <block wx:for="{{displayedCoupons}}">
      <component is="{{renderType}}" couponData="{{item}}" isSingle="{{ couponList.length==1}}" bind:clickExtra="clickExtra" />
    </block>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { trackEvent } from '@/common/track'

  createComponent({
    props: {
      // 下发的券数据
      couponList: {
        type: Array,
        value: () => []
      },
      // activityId: {
      //   type: String | Number,
      //   value: () => ''
      // }
    },
    data: {
      maxLimit: 4 // 券最大数量限制
    },
    attached() {
      // 埋点参数
      // const detail = this.displayedCoupons?.map((item) => {
      //   const coupon = item?.coupon_info
      //   return {
      //     pope_id: this.activityId,
      //     batch_id: coupon?.batch_id,
      //     status: coupon?.couponStatusInfo?.status
      //   }
      // })
      // 曝光埋点
      // trackEvent('userteam_train_coupon_banner_sw', 'UT-火车票-领券组件-展现', {
      //   detail,
      //   pg_type: 'home',
      //   num: this.displayedCoupons?.length
      // })
    },
    computed: {
      // 渲染的券数据
      displayedCoupons() {
        return this.couponList?.length > this.maxLimit ? this.couponList.slice(0, 4) : this.couponList
      },
      // 渲染哪种类型的券组件
      renderType() {
        switch (this.displayedCoupons?.length) {
          case 1:
          case 2:
            return 'large-coupon'
          case 3:
          case 4:
            return 'small-coupon'
          default:
            return ''
        }
      }
    },
    methods: {
      clickExtra(data) {
        this.triggerEvent('clickExtra', data?.detail ?? '')
      }
    },
  })
</script>

<style lang='stylus' scoped>
  .banner-container
    display flex
    height 51px
    margin-top 12px
    justify-content space-between
    overflow hidden
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'large-coupon': './large-coupon',
      'small-coupon': './small-coupon'
    }
  }
</script>
